// extracted by mini-css-extract-plugin
export default {"headerBar":"SharedDecision_headerBar__95pxp"};